import $ from "jquery";
import { enums } from "../shim/jsbridge";

class ExportGridMenu {
  constructor(element, options) {
    this.element = element;
    this.options = options;
    this.header = undefined;
    this.footer = undefined;
    this.component = undefined;
    this._keepMenuOpen = true;
    this.dataSource = $.map(enums.export_fields, field => {
      return {
        text: field.capitalize(),
        value: `include_${field}`
      };
    }).concat([
      {
        value: "_footer",
        text: `
                <span id="export_grid_footer_container">
                    <input type="text" id="export_format" style="width:80px;">
                    <button class="handle-export" data-testid="grid-export-button">Export File</button>
                </span>
            `
      }
    ]);
  }

  init() {
    $(() => {
      this.element = $(this.element);
      this._createComponent();
    });
  }

  _createComponent() {
    const $html = $("html");

    this.component = this.element
      .kendoDropDownList({
        dataTextField: "text",
        dataValueField: "value",
        autoBind: false,
        dataSource: this.dataSource,
        index: -1,
        height: 400,
        valueTemplate: '<span class="title">Export</span>',
        headerTemplate: `<span id="hash_type_dropdown_container"><input type="text" id="hash_type" style="width:180px;"></span>`,
        template: `
                # if (data.value === '_footer') { # #= data.text # # } else { #
                <span class="export-menu-row">
                    <label for="#: data.value #" class="new-checkbox" data-testid='grid-export-menu-item-#: data.text.kebabCase() #'>
                        <input id="#: data.value #" type="checkbox" name="#:data.value#" class="rl-grid-cbx" checked="checked">
                        # if (data.value !== '_header') { #
                            #:data.text#
                        # } #
                    </label>
                    # if (data.value === '_header') { #
                        #= data.text #
                    # } #
                </span>
                # } #
            `,
        select: e => {
          e.preventDefault();
        },
        open: () => {
          $html.on("click.exportHandleMenuToggle", e => {
            this.component.popup.wrapper.addClass("export-options-container");
            var target = $(e.target);
            if (
              target.closest(".export-options-container").length ||
              (target.closest(this.component.wrapper).length &&
                !this.component.popup.wrapper.hasClass("menu-open"))
            ) {
              this._keepMenuOpen = true;
              this.component.popup.wrapper.addClass("menu-open");
            } else {
              this._closeMenu();
            }
          });
        },
        close: e => {
          if (this._keepMenuOpen) {
            e.preventDefault();
          } else {
            this.component.popup.wrapper.removeClass("menu-open");
            $html.off("click.exportHandleMenuToggle");
          }
        }
      })
      .data("kendoDropDownList");

    this.component.text("Export");

    this.component.one("dataBound", () => {
      this._initHeaderAndFooter();
      $html.on(
        "click",
        ".export-options-container .handle-export",
        this.handleExport.bind(this)
      );
    });

    return this.component;
  }

  _closeMenu() {
    this._keepMenuOpen = false;
    this.component.close();
  }

  _createHeader() {
    const onHashTypeDataBound = () => {
      $("#hash_type_dropdown_container > .k-widget").attr(
        "data-testid",
        "grid-export-hash-type-dropdown"
      );
      $("#hash_type-list")
        .find(".k-list > .k-item")
        .each((idx, item) => {
          $(item).attr(
            "data-testid",
            `threat-status-filter-item-${$(item).text()}`
          );
        });
    };

    return this.component.popup.wrapper
      .find("#hash_type")
      .kendoDropDownList({
        dataTextField: "value",
        dataValueField: "text",
        index: 0,
        dataBound: onHashTypeDataBound,
        dataSource: ["sha1", "sha256", "md5"].map(d => ({
          text: d,
          value: d
        }))
      })
      .data("kendoDropDownList");
  }

  _createFooter() {
    const onExportFormatDataBound = () => {
      $("#export_grid_footer_container > .k-widget").attr(
        "data-testid",
        "export-format-dropdown"
      );
      $("#export_format-list")
        .find(".k-list > .k-item")
        .each((idx, item) => {
          var itemLabel = $(item).text().kebabCase();
          $(item).attr(
            "data-testid",
            `export-format-dropdown-item-${itemLabel}`
          );
        });
    };

    return this.component.popup.wrapper
      .find("#export_format")
      .kendoDropDownList({
        dataTextField: "value",
        dataValueField: "text",
        value: "csv",
        dataSource: $.map(enums.export_formats, (format, key) => {
          return { text: format, value: key };
        }),
        dataBound: onExportFormatDataBound
      })
      .data("kendoDropDownList");
  }

  _initHeaderAndFooter() {
    this.header = this._createHeader();
    this.footer = this._createFooter();
  }

  getExportParams() {
    var result = {
      hash_type: this.header.value(),
      export_format: this.footer.value()
    };
    this.component.list
      .find("[type=checkbox]:checked")
      .toArray()
      .forEach(el => {
        result[el.name] = true;
      });
    return result;
  }

  handleExport() {
    var reqParams = this.options.requestOptions.params();
    // this 2 elements will be present in uploads.grid.element.data('parameter-map')
    // we don't need them and after first poll request they will be filled with list of all hashes on page
    // that would break request because it will be too long
    // we need other params and easiest thing is to just delete current_hashes and status_poll_hashes
    delete reqParams.current_hashes;
    delete reqParams.status_poll_hashes;
    var params = $.param($.extend({}, reqParams, this.getExportParams()));
    window.open(this.options.requestOptions.url + "?" + params, "_blank");
    setTimeout(() => {
      this._closeMenu();
    }, 500);
  }
}

export default ExportGridMenu;
